
<div id="map" class="map"></div>

<div mat-dialog-actions>
    <button mat-button cdkFocusInitial (click)="CloseClick()">Chiudi</button>
    <button mat-button cdkFocusInitial (click)="moveToCenter()">Posiziona al centro</button>
</div>